import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Alert, Icon } from '@safedns/skydns-ui-react-lib';

import { notificationSuccess } from '../../../store/notificationReducer';

const Notification = () => {
  const dispatch = useDispatch();
  const notificationData = useSelector(
    (state) => state.notification.notification_success
  );
  const [isNotification, setIsNotification] = useState(
    notificationData.isNotification
  );

  useEffect(() => {
    const notificationDefault = {
      isNotification: false,
      type: '',
      action: '',
      message: '',
    };

    if (notificationData.isNotification) {
      setIsNotification(true);

      setTimeout(() => {
        setIsNotification(false);

        dispatch(notificationSuccess(notificationDefault));
      }, 5000);
    }
  }, [notificationData, dispatch]);

  let icon;
  switch (notificationData.type) {
    case 'success':
      icon = <Icon id="info" />;
      break;
    case 'error':
      icon = <Icon id="info" color="white" />;
      break;
    default:
      icon = <></>;
  }

  return isNotification ? (
    <Alert
      type={notificationData.type}
      icon={icon}
      sx={{ position: 'fixed', bottom: 24, left: '50%' }}
      content={notificationData.message}
    />
  ) : null;
};

export default Notification;
